import React, { useEffect } from "react";
import Steps from "./common/steps";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";


const StepsQualification = () => {

    const navigate = useNavigate(), location = useLocation();

    const steps = [
        {
            title: `Confirm Personal Info`,
            description: <>Sunbound needs to confirm your info to see if you qualify for our Pay Over Time program. There is <strong>no impact</strong> to your credit score</>
        },
        {
            title: `Complete Enrollment`,
            description: `Finish setting up your payment preferences. Sunbound will reach out shortly to confirm you’re qualified and set!`
        }
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (

        <div className="page-content-wrapper">
            <h1 className="page-header">Get qualified to pay over time</h1>
            <span className="page-subheader">Sunbound requires additional info to allow you to pay over time. Completing these easy steps takes less than two minutes</span>
            <Steps steps={steps} />
            <div className="page-action">
                <button type="button" className="btn btn-primary" onClick={() => helpers.navigateNext(location, navigate)}>Continue</button>
            </div>
        </div>
    );
};

export default StepsQualification;